// styles
import './Components.css'

export default function MessageCard({errorMessage, successMessage}) {
  return (
    <>
      {successMessage ?
        <div className="success-card">
          <p>{successMessage}</p>
        </div> : (errorMessage) &&
        <div className="error-card">
          <p>{errorMessage}</p>
        </div>
      }
    </>
  )
}